// components/Dashboard.js
import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import ClientsList from './ClientsList';
import CapsulesList from './CapsulesList';
import ItemsList from './ItemsList';
import OutfitBuilder from './OutfitBuilder';
import CapsuleItemsList from './CapsuleItemsList';
import CapsuleDetail from './CapsuleDetail';

const Dashboard = () => {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center space-x-8">
              <Link to="/" className="text-2xl font-light tracking-[0.2em] text-gray-900">
                kearaeliz
              </Link>
              <div className="flex space-x-6">
                <Link
                  to="/dashboard"
                  className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium"
                >
                  Clients
                </Link>
                <Link
                  to="/dashboard/capsules"
                  className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium"
                >
                  Capsules
                </Link>
                <Link
                  to="/dashboard/items"
                  className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium"
                >
                  Items
                </Link>
              </div>
            </div>
            
            {/* User menu */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <User className="w-4 h-4" />
                <span>{user?.email}</span>
              </div>
              <button
                onClick={handleSignOut}
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium"
              >
                <LogOut className="w-4 h-4" />
                <span>Sign Out</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <Routes>
        <Route path="/" element={<ClientsList />} />
        <Route path="/capsules" element={<CapsulesList />} />
        <Route path="/items" element={<ItemsList />} />
        <Route path="/capsules/:id/items" element={<CapsuleItemsList />} />
        <Route path="/capsules/:id/outfits/:outfitId" element={<OutfitBuilder />} />
        <Route path="/capsules/:id" element={<CapsuleDetail />} />
      </Routes>
    </div>
  );
};

export default Dashboard;